module.exports = __webpack_public_path__ + "static/media/pamain-light.d44ea5e5.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-light.eot
// module id = ./src/assets/fonts/pamain-light.eot
// module chunks = 0